import {
  Component,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { ListSpecialPaymentsGracePeriodWrapperComponent } from '@app/pages/quote/standard-quote/deals-standard-quote/list-special-payments-grace-period/list-special-payments-gp-wrapper.component';

//standard-list-special-payments-grace-period
@Component({
  selector: 'standard-list-special-payments-grace-period-mobile',
  templateUrl: './list-special-payments-gp-mobile.component.html',
  styleUrls: ['./list-special-payments-gp-mobile.component.css'],
})
export class ListSpecialPaymentsGracePeriodMobileComponent extends ListSpecialPaymentsGracePeriodWrapperComponent {
  constructor(
    route: ActivatedRoute,
    menuService: MenusServices,
    notification: NotificationService,
  ) {
    super(route, menuService, notification);
  }
}
